<p>Version UI : {{uiVersion}}</p>
<p *ngIf="apiVersion">Version API : {{apiVersion}}</p>
<h2>Statut des connexions BDD</h2>
<div class="wrapper1 shadowed">

    <mat-progress-spinner *ngIf="!status" mode="indeterminate" diameter="40">
    </mat-progress-spinner>
    <ng-container *ngIf="status">
        <table class="table">
            <caption>Servers and Database status</caption>
            <thead>
                <tr>
                    <th scope="col">Nom</th>
                    <th scope="col">Statut</th>
                </tr>
            </thead>


            <tbody>
                <tr *ngFor="let sta of status">
                    <td>{{ sta.name }}</td>

                    <ng-container *ngIf="sta.status === 'OK'">
                        <td class="material-icons" id="done">done</td>
                    </ng-container>

                    <ng-container *ngIf="sta.status === 'KO'">
                        <td class="material-icons" id="close">close</td>
                    </ng-container>

                </tr>
            </tbody>
        </table>
    </ng-container>
</div>

<h2>Changements</h2>
<div class="wrapper shadowed">
    <p>31/03/2023</p>
    <ul>
        <li>
            Modification : Le nombre de pannes sur la page de suivi des machines est maintenant correct et il est possible de trier le tableau par colonne
        </li>
    </ul>
</div>
<div class="wrapper shadowed">
    <p>29/03/2023</p>
    <ul>
        <li>
            Ajout : Il y a maintenant une extraction du nombre d'incidents passés en résolus par jour et par personne.
        </li>
    </ul>
</div>
<div class="wrapper shadowed">
    <p>23/03/2023</p>
    <ul>
        <li>
            Modification : Les éléments de l'arbre de défaillances ne sont plus repliés automatiquement après l'ajout ou la modification d'un élément.
        </li>
    </ul>
</div>
<div class="wrapper shadowed">
    <p>23/03/2023</p>
    <ul>
        <li>
            Modification : Les codes pannes d'un nouvel élément sont automatiquement ceux de l'élément parent (et toujours modifiables).
        </li>
    </ul>
</div>
<div class="wrapper shadowed">
    <p>22/03/2023</p>
    <ul>
        <li>
            Ajout : Extraction des incidents sur 12 mois glissants (comme existante sur le serveur SAV mais sans les machines non mises en service)
        </li>
    </ul>
</div>
<div class="wrapper shadowed">
    <p>17/03/2023</p>
    <ul>
        <li>
            Modification : il y a maintenant un message de confirmation d'enregsitrement sur le formulaire de rapport d'intervention.
        </li>
    </ul>
</div>
<div class="wrapper shadowed">
    <p>10/03/2023</p>
    <ul>
        <li>
            Ajout : Il est maintenant possible de modifier une intervention.
        </li>
        <li>
            Modification : Il est possible de sélectionner une installation par le numéro de série de la machine dans la création ou la modification d'une intervention.
        </li>
        <li>
            Correction : Le tri de la page "Ventes" est à nouveau fonctionnel et compatible avec le filtre de département.
        </li>
        <li>
            Ajout : la colonne numéro de série apparait sur la liste des installations "Installées" et "En service".
        </li>
        <li>
            Modification : L'extraction "Liste des pannes" permet d'obtenir le département d'installation des machines et n'extrait les pannes qu'après la mise en service des distributeurs.
        </li>
        <li>
            Modification : L'extraction "Liste des pannes" permet également de sélectionner un intervalle de dates de mise en service.
        </li>
    </ul>
</div>
<div class="wrapper shadowed">
    <p>03/03/2023</p>
    <ul>
        <li>
            Ajout : Il est maintenant possible de créer une intervention
        </li>
    </ul>
</div>
<div class="wrapper shadowed">
    <p>26/01/2023</p>
    <ul>
        <li>
            Correction : La page d'accueil ne s'affichait plus.
        </li>
    </ul>
</div>
<div class="wrapper shadowed">
    <p>24/11/2022</p>
    <ul>
        <li>
            Modification : Les types de l'arbre sont maintenant : Réponse, Solution et Elément (il n'y a plus Zone, Composant, Symptôme et Question)
        </li>
        <li>
            Modification : Les vérifications sur l'arbre faible / fort sont remplacées par client / technicien 
        </li>
        <li>
            Modification : Le nom des codes pannes apparait maintenant sur l'extraction "Nombre drocurrences par code panne"
        </li>
        <li>
            Correction : Il est maintenant possible de modifier plus d'une fois un élément du guide de réussite
        </li>
        <li>
            Correction : Il n'y a plus de doublon sur l'affichage du guide de réussite
        </li>
    </ul>
</div>
<div class="wrapper shadowed">
    <p>12/10/2022</p>
    <ul>
        <li>
            Modification : Ouverture des liens de la page "Liste des appels" dans un nouvel onglet
        </li>
        <li>
            Correction : Le contrat en cours apparait sur le détail de l'appel
        </li>
    </ul>
</div>
<div class="wrapper shadowed">
    <p>03/10/2022</p>
    <ul>
        <li>
            Ajout : filtre de validation (Vérifié, non vérifié, OK, NOK) à la recherche d’appels
        </li>
        <li>
            Modification : Ouverture des liens de cette recherche dans un nouvel onglet
        </li>
        <li>
            Ajout : export de liste de pannes remontées par Pizzadoor 
        </li>
    </ul>
</div>
<div class="wrapper shadowed">
    <p>13/07/2022</p>
    <ul>
        <li>
            Ajout : Possibilité de marquer un incident comme traité
        </li>
        <li>
            Ajout : Possibilité de voir qui a marqué les incidents comme traités (avec la date)
        </li>
        <li>Ajout : Possibilité de valider ou non les rapports d'intervention
        </li>
        <li>
            Ajout : Possibilité de voir qui a validé le rapport d'intervention (avec la date)
        </li>
        <li>Correction : La recherche de liste d'appels ne fait plus apparaitre de doublon</li>
    </ul>
</div>
<div class="wrapper shadowed">
    <p>24/06/2022</p>
    <ul>
        <li>
            Modification : Rechercher une liste d'appels :
            <br> Ajout d'un filtre de hotliner(s)
            <br> Ajout d'un filtre de département(s)
        </li>
        <li>
            Modification : Page Ventes : ajout d'un filtre de département(s)
        </li>
    </ul>
</div>
<div class="wrapper shadowed">
    <p>13/06/2022</p>
    <ul>
        <li>
            Modification : Sauvegarde de la session. Plus besoin de se reconnecter à chaque rechargement de la page. 
        </li>
    </ul>
</div>
<div class="wrapper shadowed">
    <p>09/06/2022</p>
    <ul>
        <li>
            Ajout : Le nombre d'installations du mois échu apparait sur la page d'Accueil
        </li>
    </ul>
</div>
<div class="wrapper shadowed">
    <p>03/06/2022</p>
    <ul>
        <li>
            Modification : L'indicateur de fiabilité est maintenant séparé en 3 onglets : Global, Pizzadoor, Panidoor
        </li>
        <li>
            Modification : Le total des ventes par monnaie inclus maintenant toutes les monnaies prises en charge par
            Pizzadoor
        </li>
        <li>
            Modification : L'export de liste d'appels indique l'heure de l'appel en plus de la date
        </li>
        <li>
            Modification : La page "Ventes" a un temps de chargement raccourci et affiche le nom entier des
            installations
        </li>
        <li>
            Modification : L'export de liste de contrats inclus désormais un intervalle de fin de contrat.
            <br> L'adresse mail du client et le code postal de l'installation sont également ajoutés aux résultats
        </li>
        <li>
            Modification : Il est maintenant possible d'exporter des appels concernant des installations mises en
            services après une date entrée dans le formulaire
            <br> La date de mise en service est également ajoutée aux résultats
        </li>
    </ul>
</div>

<div class="wrapper shadowed">
    <p>27/04/2022</p>
    <ul>
        <li>
            Ajout: Possibilité de créer un message, de le modifier, de le supprimer, d'ajouter et retirer des
            installations
        </li>
        <li>
            Ajout de la date d'installation sur les liste d'installations "Installées" et "En service"
        </li>
    </ul>
</div>

<div class="wrapper shadowed">
    <p>15/04/2022</p>
    <ul>
        <li>
            Ajout: Page messages aux installations
        </li>
    </ul>
</div>

<div class="wrapper shadowed">
    <p>14/04/2022</p>
    <ul>
        <li>
            Ajout: Page matériel avec informations et historique
        </li>
    </ul>
</div>

<div class="wrapper shadowed">
    <p>13/04/2022</p>
    <ul>
        <li>
            Ajout: Affichage des avertissements sur la page d'accueil : backups incomplets, installations enregistrant
            des ventes mais non mises en service, installations non connectées récement
    </ul>
</div>

<div class="wrapper shadowed">
    <p>21/03/2022</p>
    <ul>
        <li>
            Ajout: Affichage des versions UI et API sur la page Changelogs (c'est ici)
    </ul>
</div>

<div class="wrapper shadowed">
    <p>18/03/2022</p>
    <ul>
        <li>
            Ajout: Consultation des rapports d'erreur sur la page installation
        </li>
    </ul>
</div>
<div class="wrapper shadowed">
    <p>16/03/2022</p>
    <ul>
        <li>
            Ajout: possibilité de consulter les pages d'incidents d'une installation (seulement la première page était
            disponible)
        </li>
    </ul>
</div>
<div class="wrapper shadowed">
    <p>14/03/2022</p>
    <ul>
        <li>
            Ajout : possibilité d'obtenir les installations mises en services depuis une date séléctionnée
        </li>
    </ul>
</div>
<div class="wrapper shadowed">
    <p>10/03/2022</p>
    <ul>
        <li>
            Ajout : possibilité d'obtenir le nombre d'occurrences par code panne sur une période séléctionnée
        </li>
    </ul>
</div>
<div class="wrapper shadowed">
    <p>09/03/2022</p>
    <ul>
        <li>
            Ajout : possibilité de cliquer sur un mois dans fiabilité mensuelle pour afficher le détail des défaillances
            prises en compte.
        </li>
    </ul>
</div>

<div class="wrapper shadowed">
    <p>09/02/2022</p>
    <ul>
        <li>
            Ajout : page Admin, onglet 'arbre' : gestion du guide réussite / arbre de défaillances
        </li>
    </ul>
</div>

<div class="wrapper shadowed">
    <p>06/02/2022</p>
    <ul>
        <li>
            Ajout : page Incidents, Filtrer les incidents par date de mise en service du distributeur
        </li>
    </ul>
</div>

<div class="wrapper shadowed">
    <p>03/02/2022</p>
    <ul>
        <li>
            Ajout : page Admin, onglet 'gestion' : gestion des pannes (catégories et codes), actions SAV, intervenants
            SAV, types d'appels SAV [ liste / ajout / suppression / modification ].
        </li>
    </ul>
</div>

<div class="wrapper shadowed">
    <p>15/11/2021</p>
    <ul>
        <li>
            Ajout : page Admin. Gestion des utilisateurs [ liste / ajout / suppression / modification ]. En cours de
            finalisation ( données non réellement modifiées )
        </li>
    </ul>
</div>

<div class="wrapper shadowed">
    <p>03/11/2021</p>
    <ul>
        <li>
            Modification : page récapitulatif des ventes. Possibilité d'exporter les données au format CSV +
            amélioration de l'affichage.
            <!-- FMT -->
        </li>
    </ul>
</div>

<div class="wrapper shadowed">
    <p>02/11/2021</p>
    <ul>
        <li>
            Ajout : page Admin. Possibilité d'afficher et d'exporter au format CSV la liste des appels en fonction d'une
            date de début et de fin, d'un type de contrat, d'un type d'action, d'un intervenant.
            <!-- FMT -->
        </li>
    </ul>
</div>



<div class="wrapper shadowed">
    <p>02/11/2021</p>
    <ul>
        <li>
            Ajout : Admin/graphiques : donne accès aux graphs Power-BI
            <!-- BLY -->
        </li>
        <li>
            Ajout : Admin / Pannes Stats : Plein de statistiques sur les pannes
            <!-- BLY -->
        </li>
    </ul>
    <p>25/10/2021</p>
    <ul>
        <li>
            Modification : l'icone et le texte de la navigation changent de couleur uniquement quand l'utilisateur a
            cliqué sur le lien.
            <!-- FMT -->
        </li>
        <li>
            Modification : aspect de la page "Admin - extraction"
            <!-- FMT -->
        </li>
        <li>
            Ajout : onglet "ventes", possibilité de changer l'année.
            <!-- FMT -->
        </li>
    </ul>
</div>

<div class="wrapper shadowed">
    <p>19/10/2021</p>
    <ul>
        <li>
            Suppression : Item "Séries" dans le menu. Ne semble plus utilisé
            <!-- BLY -->
        </li>
        <li>
            Ajout : Loading dans l'écran "Outils". Modification du titre de cette page.
            <!-- BLY -->
        </li>
        <li>
            Ajout : "Administration" / "Fiabilité" : affiche le taux de fiabilité des distributeurs sortis d'usine.
            <!-- BLY -->
        </li>
    </ul>
</div>

<div class="wrapper shadowed">
    <p>21/09/2021</p>
    <ul>
        <li>
            Ajout : Liste des incidents dans la page installation
            <!-- EBS -->
        </li>
    </ul>
</div>

<div class="wrapper shadowed">
    <p>20/09/2021</p>
    <ul>
        <li>
            Modification : La page "Login" n'affiche plus le password en clair
        </li>
        <li>
            Ajout : pagination dans la page "Appels"
        </li>
        <li>
            Modification : La page "Panne" affiche en premier lieu l'ensemble des pages non-traitées, puis le suivi des
            pannes en cliquant sur "voir le suivi"
        </li>
        <li>
            Ajout : Lien "retour à la liste des appels" sur la page détail d'un appel
        </li>
        <li>
            Ajout : Les appels de la page "Installation", onglet 'interventions' sont cliquables, et mènent aux détails
            de l'appel.
        </li>
        <li>Ajout : système d'accordéon sur la page 'Incidents-list'</li>
    </ul>
</div>


<div class="wrapper shadowed">
    <p>17/09/2021</p>
    <ul>
        <li>
            Ajout : Page "Changelogs" ( vous êtes dessus )
        </li>
        <li>
            Ajout : Status des connexions dans la page "Changelogs"
        </li>
        <li>
            Modification : Page "Accueil" est présentée en onglets
        </li>
        <li>
            Ajout : Page "Administration". Destinée à afficher :
            <ul>
                <li>les extractions possibles</li>
                <li>la gestion des utilisteurs GMAO</li>
            </ul>
        </li>
        <li>
            Suppression : Pages "Personnes", "Société", "Messages"
        </li>
        <li>
            Modification : La Page "Interventions" est renommée "Appels" ( manque la pagination )
        </li>
        <li>
            Ajout : Lien depuis la page "Appels" vers la page "Installation"
        </li>
        <li>
            Modification : La Pages "Satistiques" et renommée "Récapitulatif des ventes"
        </li>
        <li>
            Modification : La taille des cases de la Page "Série" est fixe
        </li>
    </ul>
</div>

<br />